import request from '@/utilsCloud/request'
import port from './port'

// 获取考试列表
export function getGatewayNoticeList(query) {
  return request({
    url: port.biz + '/notice/getGatewayNoticeList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function getGatewayNoticeDetails(query) {
  return request({
    url: port.biz + '/notice/getGatewayNoticeDetails',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/notice.js